export default __webpack_public_path__ + "static/media/chevron-arrow.05c9f321.svg";